
export default {
    // @StandardPricing
    setNewCreatedStandardPricingMaster(state, value){
        state.newCreatedStandardPricingMaster = value
    },
    setNewCreatedStandardPricing(state, value){
        state.newCreatedStandardPricing = value
    }
}